import errorTrackingService from 'utils/services/errorTrackingService'

import { HighlightIdentify } from './constants'

type HighlightModule = typeof import('highlight.run')

type Identifier = `${HighlightIdentify}_${string}`

export class HighlightService {
  private isInitialized = false
  private H: HighlightModule['H'] | null = null
  private identifier: Identifier | null = null

  private sendError = (method: 'import' | 'init' | 'start' | 'stop'): void => {
    errorTrackingService.logError(`Method - ${method}: has error`, {
      scope: 'root',
      section: null,
      fingerprint: 'highlight-service',
    })
  }

  private async loadHighlightLibrary(): Promise<void> {
    try {
      const highlightModule = await import('highlight.run')
      this.H = highlightModule.H
    } catch (error) {
      this.sendError('import')
    }
  }

  public isServiceInitialized(): boolean {
    return this.isInitialized
  }

  public async init(
    projectID: string,
    params: Parameters<HighlightModule['H']['init']>[1],
  ): Promise<void> {
    if (!this.isInitialized) {
      try {
        if (!this.H) {
          await this.loadHighlightLibrary()
        }
        this.H?.init(projectID, params)
        this.isInitialized = true
      } catch (_error) {
        this.sendError('init')
      }
    }
  }

  public start() {
    if (!this.isInitialized) {
      return
    }

    try {
      this.H?.start()
    } catch (_error) {
      this.sendError('start')
    }
  }

  public stop() {
    if (!this.isInitialized) {
      return
    }

    try {
      this.H?.stop()
    } catch (_error) {
      this.sendError('stop')
    }
  }

  public identify(
    identifier: Identifier,
    metadata?: Parameters<HighlightModule['H']['identify']>[1],
  ) {
    if (this.identifier === null) {
      this.H?.identify(identifier, metadata)
      this.identifier = identifier
    }
  }
}

export default new HighlightService()
